<template>
    <div class="teacher">
        <Header></Header>

        <div style="width: 1500px;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
            'margin-left': innerWidth > 1500 ? (innerWidth - 1500) / 2 + 'px' : '0px',
            'height': (innerHeight - 70 - 68) + 'px'
        }">

            <div class="chooseType" style="min-height:50px;height:auto;">
                <div class="courseNavBox fl" v-for="(item, index) in categoryTypeList" :key="index">
                    <div class="list" :class="curTypeId == item.examCategoryId ? 'active' : ''"
                        @click="switchType(item)">
                        {{ item.examCategoryName }}
                    </div>
                </div>
            </div>


            <div class="teacherBox" style="clear: both;">
                <a target="_blank" @click="goDetail(teacher.teacherId)" v-for="(teacher, index) in teacherList" :key="index" class="teacherItem">
                    <div class="teacherImg"><img
                            :src="teacher.avatarUrl"
                            alt=""></div>
                    <div class="teacherContent">
                        <div class="teacherName">
                            {{teacher.teacherName}}
                        </div>
                        <div class="scroll">
                            <div class="teacherTags" >
                                <div class="tags" v-for="(tag, tagIndex) in teacher.tags" :key="tagIndex">
                                    {{tag.name}}
                                </div>
                            </div>
                            <div class="teacherDescription">
                               {{teacher.intro}}
                            </div>
                        </div>
                        <div class="goDetail">进入主页</div>
                    </div>
                </a>
            </div>

        </div>
        <Suspension></Suspension>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "../components/common/Header"
import Footer from "../components/common/Footer"
import Suspension from "../components/common/Suspension"

import {
    getByUrl,
    getByParam
} from '@/api/api.js';

export default {
    name: "Teacher",
    data() {
        return {
            query: {
                page: 1,  // 第几页
                size: 10,  // 每页多少条
                total: 0,
            },
            curTypeId: '',
            categoryTypeList: [],
            teacherList: [],
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    },
    mounted() {
        this.getCategoryList()

    },
    methods: {
        goDetail(id){
            this.$router.push({
                path: '/teacher/det',
                query: {
                 id: id
                }
            })
        },
        switchType(item) {
            this.curTypeId = item.examCategoryId
            this.getCategoryTeacher(this.curTypeId)
        },
        handleSizeChange(e) {
            console.log('e', e)
            this.query.size = e;
            this.getCategoryTeacher(this.curTypeId);
        },

        getCategoryList() {
            this.categoryTypeList.push({
                examCategoryId: '',
                examCategoryName: '全部'
            })
            getByUrl('/web/examCategory/list').then(res => {
                console.log(res)
                for (let i = 0; i < res.data.length; i++) {
                    this.categoryTypeList.push({
                        examCategoryId: res.data[i].examCategoryId,
                        examCategoryName: res.data[i].name
                    })
                }
                this.getCategoryTeacher('')
            })

        },
        getCategoryTeacher(id) {
            let param = {
                examCategoryId: id,
                pageNum: 1,
                pageSize: 100
            }
            getByParam('/web/examCategoryTeacher/page', param).then(res => {
                console.log(res)
                this.teacherList = res.data.pageInfo.list
            })
        },
    },
    components: {
        Header,
        Footer,
        Suspension
    }
}
</script>

<style scoped>
.chooseType {
    margin-top: 24px;
    padding: 16px 24px 0;
    border-radius: 8px;
    /* background: #fff; */
}

.chooseTypeText {
    width: 70px;
    font-size: 14px;
    line-height: 36px;
    margin-right: 8px;
    color: #2b2e33;
    float: left;

}

.list {
    border-radius: 16px;
    background: #f7f8fa;
    color: #737780;
    font-weight: 300;
    font-size: 14px;
    padding: 9px 16px;
    cursor: pointer;
    line-height: 14px;
    margin-left: 15px;
    margin-bottom: 20px;
    /* -webkit-transition: all .3s;
  transition: all .3s; */
}

.active {
    line-height: 14px;
    height: 32px;
    border-radius: 20px;
    box-sizing: border-box;
    color: #399df6;
    font-weight: 600;
    border: .5px solid rgba(5, 193, 183, .10196078431372549);
    background: rgba(5, 193, 183, .10196078431372549);
    box-shadow: 0 4px 8px rgba(0, 204, 156, .0784313725490196);
}

.teacherBox {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
}

.teacherItem {
    margin-top: 20px;
    cursor: pointer;
    height: 228px;
    overflow: hidden;
    padding: 24px;
    display: flex;
    border-radius: 6px;
    border: .5px solid var(--gray_95);
    box-sizing: border-box;
    background: #fff;
}

.teacherImg {
    flex-shrink: 0;
    width: 180px;
    height: 180px;
    border-radius: 4px;
    margin-right: 24px;
}

.teacherImg img {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    display: block;
}

.teacherContent {
    margin-top: 4px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
    overflow: hidden;
    padding-bottom: 40px;
}

.teacherName {
    color: #000;
    font-weight: 600;
    font-size: 20px;
}

.scroll {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.teacherTags {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 8px;
}

.tags {
    flex-shrink: 0;
    height: 24px;
    padding: 0 15px;
    line-height: 24px;
    border-radius: 6px;
    background: linear-gradient(90deg, #f7deca, #eec9a1);
    text-align: center;
    color: #915e37;
    font-weight: 500;
    font-size: 12px;
    margin-right: 10px;
    margin-top: 8px;
}

.teacherDescription {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #000;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
}

.goDetail {
    position: absolute;
    right: 0;
    width: 88px;
    height: 32px;
    border-radius: 16px;
    line-height: 32px;
    background: #EDEFF2;
    text-align: center;
    color: #737780;
    font-weight: 400;
    font-size: 14px;
}
</style>